<template>
  <LoadingContainer :is-loading="isLoading">
    <div class="card">
      <div class="card-header">
        <div class="card-header-title">
          {{ titleDescription }}
        </div>
        <div class="card-header-icon">
          <div class="field has-addons is-marginless">
            <div class="control">
              <router-link
                :to="{ name: 'marketing.contests.list' }"
                class="button"
              >
                <span class="icon is-small"><i class="fa fa-list-ul"/></span
                ><span>Λίστα</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <form @submit.prevent="submit">
        <div class="card-content">
          <AddPhotos
            :title="'Contest Image'"
            :preview="preview"
            :show-error="errors.has('image')"
            @addPhotos="handleAddPhotos"
          />

          <div class="field">
            <label class="label">Τίτλος *</label>
            <div class="control">
              <input
                v-validate="'required'"
                v-model.trim="form.title"
                class="input"
                type="text"
                name="title"
              />
            </div>
            <p v-show="errors.has('title')" class="help is-danger">
              Εισάγετε ονομασία
            </p>
          </div>

          <div class="field">
            <label class="label">Slug *</label>
            <div class="control">
              <input
                v-validate="'required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'"
                v-model.trim="form.slug"
                class="input"
                type="text"
                name="slug"
              />
              <div v-show="errors.has('slug')" class="help is-danger">
                Εισάγετε έγκυρο slug
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">Περιγραφή *</label>
            <div class="control">
              <textarea
                v-validate="'required'"
                v-model.trim="form.description"
                class="textarea"
                name="description"
              />
              <p v-show="errors.has('description')" class="help is-danger">
                Εισάγετε περιγραφή
              </p>
            </div>
          </div>

          <div class="field">
            <label class="label">Εμφάνιση κουμπιού διαγωνισμού</label>
            <div class="control">
              <ToggleButton
                :sync="true"
                :value="form.show_button"
                :color="{ checked: '#22A684', unchecked: '#ff3860' }"
                :width="30"
                :height="15"
                @change="updateShowButton"
              />
            </div>
          </div>

          <div v-if="form.show_button" class="field">
            <label class="label">Κείμενο Κουμπιού *</label>
            <div class="control">
              <input
                v-validate="form.show_button ? 'required|max:191' : ''"
                v-model.trim="form.button_name"
                class="input"
                type="text"
                name="button_name"
              />
            </div>
            <p v-show="errors.has('button_name')" class="help is-danger">
              Εισάγετε κείμενο κουμπιού
            </p>
          </div>

          <div v-if="form.show_button" class="field">
            <label class="label">Link Κουμπιού *</label>
            <div class="control">
              <input
                v-validate="form.show_button ? 'required|url|max:2048' : ''"
                v-model.trim="form.button_url"
                class="input"
                type="text"
                name="button_url"
                placeholder="https://..."
              />
            </div>
            <p v-show="errors.has('button_url')" class="help is-danger">
              Εισάγετε έγκυρο link
            </p>
          </div>

          <label class="label">
            Ημερομηνία Εκκίνησης *
          </label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <Datepicker
                v-validate="'required'"
                v-model="form.starts_at"
                name="starts_at"
                format="dd-MM-yyyy"
                language="el"
                wrapper-class="field"
                input-class="input"
                placeholder="πχ: 02-12-2017"
              />
              <p v-show="errors.has('starts_at')" class="help is-danger">
                Εισάγετε ημ/νία εκκίνησης
              </p>
            </div>
          </div>

          <label class="label">
            Ημερομηνία Λήξης *
          </label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <Datepicker
                v-validate="'required'"
                v-model="form.ends_at"
                name="ends_at"
                format="dd-MM-yyyy"
                language="el"
                wrapper-class="field"
                input-class="input"
                placeholder="πχ: 02-12-2017"
              />
              <p v-show="errors.has('ends_at')" class="help is-danger">
                Εισάγετε ημ/νία λήξης
              </p>
            </div>
          </div>

          <div class="field">
            <label class="label">Όροι Διαγωνισμού *</label>
            <div class="control">
              <VueEditor
                v-validate="'required'"
                id="editor"
                v-model="form.terms"
                :editor-toolbar="toolbarOptions"
                data-vv-value-path="value"
                data-vv-name="terms"
                @input="changeContent"
              />
              <p v-show="errors.has('terms')" class="help is-danger">
                Εισάγετε Όρους
              </p>
            </div>
          </div>

          <div class="field">
            <label class="label">Εμφανές</label>
            <div class="control">
              <ToggleButton
                :sync="true"
                :value="form.active"
                :color="{ checked: '#22A684', unchecked: '#ff3860' }"
                :width="30"
                :height="15"
                @change="updateActive"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">E-shop URL</label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <input
                  ref="eshopPath"
                  :value="eshopPath"
                  name="eshopPath"
                  class="input"
                  type="text"
                  readonly
                />
              </div>
              <div class="control">
                <button
                  v-tooltip="'Copy eshop path'"
                  class="button"
                  @click.prevent="handleCopy"
                >
                  <span class="icon"><i class="fa fa-clone"/></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <FormSubmit :is-saving="isSaving" @reset="reset" />
        </div>
      </form>
    </div>
  </LoadingContainer>
</template>

<script>
import moment from 'moment';
import pick from 'lodash/pick';
import { mapActions, mapGetters } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import { VueEditor } from 'vue2-editor';
import { isEmpty } from 'lodash';

import slug from 'slug';
import AddItem from '@/views/components/AddItem';
import LoadingContainer from '@/views/components/LoadingContainer';
import AddPhotos from '@/views/components/AddPhotos';
import toolbarOptions from '@/constants/toolbarOptions';
import request from '@/utils/request';

export default {
  components: {
    Datepicker,
    LoadingContainer,
    AddPhotos,
    VueEditor,
  },
  extends: AddItem,

  data() {
    return {
      contest: {},
      form: {
        title: '',
        slug: '',
        description: '',
        image: null,
        active: false,
        terms: '',
        starts_at: moment().toDate(),
        ends_at: null,
        show_button: false,
        button_name: '',
        button_url: '',
      },
      preview: '',
      toolbarOptions,
    };
  },

  computed: {
    ...mapGetters({
      isLoading: 'contests/edit/getIsLoading',
    }),

    eshopPath() {
      return `https://carespot.gr/contests/${this.contest.slug}`;
    },

    titleDescription() {
      /* eslint-disable */
      if (this.contest.deleted_at !== null) {
        return 'Ακυρωμένος Διαγωνισμός';
      } else if (this.contest.active === true) {
        return 'Ενεργός Διαγωνισμός';
      } else if (this.contest.active === false) {
        return 'Μη Ενεργός Διαγωνισμός';
      } else {
        return 'Διαγωνισμός';
      }
    },
  },

  watch: {
    'form.title': function(newVal) {
      this.form = {
        ...this.form,
        slug: slug(newVal.toLowerCase()),
      };
    },
  },

  async created() {
    try {
      const { data } = await request.get(
        `/contests/${this.$route.params.uuid}`,
      );

      const { contest } = data;

      this.contest = contest;
      this.form = {
        ...this.form,
        ...pick(this.contest, [
          'title',
          'slug',
          'description',
          'active',
          'terms',
          'starts_at',
          'ends_at',
        ]),
        // Convert numeric/boolean values to proper booleans
        show_button: !!this.contest.show_button,
        button_name: this.contest.button_name || '',
        button_url: this.contest.button_url || '',
      };
      this.preview = this.contest.image_url;
      let response = await fetch(this.preview);
      let imageData = await response.blob();
      let metadata = {
        type: 'image/jpeg',
      };
      let file = new File([imageData], 'test.jpg', metadata);
      this.form.image = file;
      // ... do something with the file or return it
    } catch (err) {
      this.$router.push('/error').catch(e => console.log(e));
    }
  },

  methods: {
    ...mapActions({
      updateContest: 'contests/edit/updateContest',
    }),

    async submit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (isEmpty(this.preview)) {
          this.errors.add({
            field: 'image',
            msg: 'Image is required',
          });
        }

        if (!isValid || isEmpty(this.preview)) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;

        // Build FormData with all fields including button fields
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('slug', this.form.slug);
        formData.append('description', this.form.description);
        formData.append('image', this.form.image);
        formData.append('active', this.form.active.toString());
        formData.append('terms', this.form.terms);
        formData.append('show_button', this.form.show_button.toString());
        formData.append('button_name', this.form.button_name);
        formData.append('button_url', this.form.button_url);
        formData.append(
          'starts_at',
          moment(this.form.starts_at).format('YYYY-MM-DD'),
        );
        formData.append(
          'ends_at',
          moment(this.form.ends_at).format('YYYY-MM-DD'),
        );

        const { data } = await request.post(
          `/contests/${this.contest.uuid}`,
          formData,
        );

        this.isSaving = false;

        if (data.error) {
          throw Error('Server-side validation failed');
        }

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Ο διαγωνισμός αποθηκεύτηκε',
        });
      } catch (err) {
        console.log(err);
        this.isSaving = false;
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },

    reset() {
      this.form = {
        ...this.form,
        ...pick(this.contest, [
          'title',
          'slug',
          'description',
          'image',
          'active',
          'terms',
          'starts_at',
          'ends_at',
        ]),
        show_button: !!this.contest.show_button,
        button_name: this.contest.button_name || '',
        button_url: this.contest.button_url || '',
      };

      this.preview = this.contest.image_url;

      this.$validator.reset();
      this.errors.remove('image');
    },

    handleAddPhotos(image) {
      console.log('image');
      this.form.image = image;

      const reader = new FileReader();

      this.$validator
        .validateAll()
        .then(() => {
          reader.onload = e => {
            this.preview = e.target.result;
            this.errors.remove('image');
          };
          reader.readAsDataURL(image);
        })
        .catch(err => console.log(err));
    },

    updateActive({ value }) {
      this.form = {
        ...this.form,
        active: !!value,
      };
    },

    updateShowButton({ value }) {
      const enabled = !!value;

      this.form = {
        ...this.form,
        show_button: enabled,
        button_name: enabled ? this.form.button_name : '',
        button_url: enabled ? this.form.button_url : '',
      };
    },

    handleCopy() {
      const copyText = this.$refs.eshopPath;
      copyText.select();
      document.execCommand('copy');

      this.$notify({
        type: 'success',
        title: 'Επιτυχία',
        text: 'Το path αντιγράφτηκε στο clipboard',
      });
    },

    changeContent(terms) {
      this.form = {
        ...this.form,
        terms: terms === '<p><br></p>' ? '' : terms,
      };
    },
  },
};
</script>
